"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PubSubHeaderT = exports.PubSubHeader = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const pub_sub_union_js_1 = require("../../solarxr-protocol/pub-sub/pub-sub-union.js");
class PubSubHeader {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsPubSubHeader(bb, obj) {
        return (obj || new PubSubHeader()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsPubSubHeader(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new PubSubHeader()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    uType() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : pub_sub_union_js_1.PubSubUnion.NONE;
    }
    u(obj) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__union(obj, this.bb_pos + offset) : null;
    }
    static startPubSubHeader(builder) {
        builder.startObject(2);
    }
    static addUType(builder, uType) {
        builder.addFieldInt8(0, uType, pub_sub_union_js_1.PubSubUnion.NONE);
    }
    static addU(builder, uOffset) {
        builder.addFieldOffset(1, uOffset, 0);
    }
    static endPubSubHeader(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createPubSubHeader(builder, uType, uOffset) {
        PubSubHeader.startPubSubHeader(builder);
        PubSubHeader.addUType(builder, uType);
        PubSubHeader.addU(builder, uOffset);
        return PubSubHeader.endPubSubHeader(builder);
    }
    unpack() {
        return new PubSubHeaderT(this.uType(), (() => {
            const temp = (0, pub_sub_union_js_1.unionToPubSubUnion)(this.uType(), this.u.bind(this));
            if (temp === null) {
                return null;
            }
            return temp.unpack();
        })());
    }
    unpackTo(_o) {
        _o.uType = this.uType();
        _o.u = (() => {
            const temp = (0, pub_sub_union_js_1.unionToPubSubUnion)(this.uType(), this.u.bind(this));
            if (temp === null) {
                return null;
            }
            return temp.unpack();
        })();
    }
}
exports.PubSubHeader = PubSubHeader;
class PubSubHeaderT {
    constructor(uType = pub_sub_union_js_1.PubSubUnion.NONE, u = null) {
        this.uType = uType;
        this.u = u;
    }
    pack(builder) {
        const u = builder.createObjectOffset(this.u);
        return PubSubHeader.createPubSubHeader(builder, this.uType, u);
    }
}
exports.PubSubHeaderT = PubSubHeaderT;
